/*
 * Слэш-локап тем strategai и strategai-light — брендбук StrategAI v3.7: JetBrains Mono 700
 * «исключительно логотип», слэш оранжевый, текст белый на тёмной сцене и тёмный на светлой.
 * Цвета — токены того элемента, где стоит знак (`--ink` текста, `--violet` — слот акцента),
 * поэтому на плашке переключателя он берёт палитру своей темы, а не страницы. Слэш — знак, а
 * не текст: он остаётся на `--violet`, а не на `--accent-ink` (tokens.css), и в светлой теме
 * оранжевый, как в брендбуке.
 *
 * Знак-сетка GeoBoost своих стилей здесь не имеет: он рисуется глобальными `.brand`/`.wm`
 * (base.css), как и до переключателя.
 */

.lockup {
  display: inline-flex;
  align-items: baseline;
  font-family: var(--logo-font);
  font-weight: 700;
  letter-spacing: -0.02em;
  line-height: 1;
  color: var(--ink);
  white-space: nowrap;
}

/* Слэш стоит вплотную к тексту: это одна «команда», а не символ рядом со словом. */
.slash {
  color: var(--violet);
}

.header {
  font-size: 18px;
}
.login {
  font-size: 20px;
}
.menu {
  font-size: 17px;
}
